<div class="bl-margin-top--16">
  <div *ngFor="let account of mainAccount; let i = index;">
    <div class="bl-font-color--base bl-margin-top--16 bl-padding-y--24 bl-padding-x--16 bl-bg-color--snow">
      <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 ">
        <input type="checkbox" [(ngModel)]="account.isSelected" name="{{account.name}}-accounts-{{i}}"
          id="{{account.name}}-accounts-{{i}}"
          [attr.data-automation-id]="'other-primary-accounts-'+i"
          class="bl-display--inline-block"
          (change)="primaryShareSelection(account)">
        <label for="{{account.name}}-accounts-{{i}}" class="bl-font-color--black bl-font-weight--900 bl-font-size--18">
          {{account.name}}
        </label>
      </div>
      <div class="bl-font-color--steel bl-font-color--black bl-font-size--16 bl-margin-top--16"
        *ngIf="account.description" [innerHtml]="account.description|safe:'html'"></div>
      <div class="bl-padding-left--32" *ngIf="hasJointApplicants(account) && account.isSelected && hasCoApplicant() && hasCoApplicantShares(i)">
        <div class="bl-font-size--16 bl-font-color--steel bl-margin-bottom--8 bl-margin-top--16 bl-font-weight--800">
          {{'oaoCheckingSavingAccounts/CoAppShares'|dictionary}}</div>
        <div *ngFor="let applicant of coAppProducts; let z = index;">
          <div
            class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450"
            [class.bl-margin-bottom--16]="z < coAppProducts.length-1">
            <input type="checkbox" name="other-{{applicant.applicantId}}-{{applicant.shares[i].id}}-accounts-{{z}}"
              id="other-{{applicant.applicantId}}-{{applicant.shares[i].id}}-accounts-{{z}}"
              [attr.data-automation-id]="'other-co-app-accounts-'+z"
              class="bl-display--inline-block" [(ngModel)]="applicant.shares[i].isSelected"
              (change)="coAppShareSelection(account, applicant)"
              [disabled]="(!account.isSelected) || (applicant.shares[i].isDisabled && applicant.shares[i].isDisabled === true)">
            <label for="other-{{applicant.applicantId}}-{{applicant.shares[i].id}}-accounts-{{z}}"
              class="bl-font-color--black  bl-font-size--16">
              {{applicant.firstName | titlecase}} {{applicant.lastName | titlecase}}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>